import { sentryMask } from 'sentryReplayPrivacy';
import { TextField, TextFieldProps } from '@mui/material';
import { styled } from '@mui/material/styles';

interface MobileNoteInputProps extends Omit<TextFieldProps, 'multiline'> {
  maxLength?: number;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 12,
    fontSize: 16,
    backgroundColor: 'transparent',
    '& fieldset': {
      borderColor: theme.palette.divider,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.divider,
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.Mui-focused': {
      backgroundColor: 'transparent',
      '& fieldset': {
        borderColor: theme.palette.divider,
      },
    },
  },
  '& .MuiOutlinedInput-input': {
    fontSize: 16,
    padding: '12px 14px',
    '&:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 100px white inset',
      WebkitTextFillColor: theme.palette.text.primary,
    },
  },
  '& .MuiFormHelperText-root': {
    fontSize: 14,
    marginLeft: 0,
  },
}));

const MobileNoteInput = ({
  maxLength,
  value,
  onChange,
  placeholder = 'Add a note...',
  rows = 4,
  ...props
}: MobileNoteInputProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    if (maxLength && newValue.length > maxLength) {
      return;
    }
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <StyledTextField
      {...props}
      multiline
      rows={rows}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      variant="outlined"
      fullWidth
      InputProps={{
        ...props.InputProps,
        // SEE-1834: notes are free text, masked in session replays.
        inputProps: {
          ...sentryMask,
          ...(maxLength && { maxLength }),
        },
      }}
      helperText={maxLength ? `${String(value || '').length}/${maxLength} characters` : props.helperText}
    />
  );
};

export default MobileNoteInput;
